import React, { useState } from 'react';
import { Tree } from '../types/Tree';
import { getQuestionAnswer } from '../data/questionAnswers';
import './QuestionInterface.css';

interface QuestionInterfaceProps {
  tree: Tree;
}

interface AskedQuestion {
  question: string;
  answer: string;
  followUps: string[];
}

const QuestionInterface: React.FC<QuestionInterfaceProps> = ({ tree }) => {
  const [currentQuestion, setCurrentQuestion] = useState('');
  const [askedQuestions, setAskedQuestions] = useState<AskedQuestion[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleQuestionSubmit = async (question: string) => {
    if (!question.trim()) return;

    setIsLoading(true);
    
    // Simulate API call delay
    setTimeout(() => {
      const answer = getQuestionAnswer(question, tree);
      
      const newQuestion: AskedQuestion = {
        question: question,
        answer: answer.answer,
        followUps: answer.followUpQuestions
      };
      
      setAskedQuestions(prev => [...prev, newQuestion]);
      setCurrentQuestion('');
      setIsLoading(false);
    }, 1000);
  };

  const handleSuggestedQuestion = (question: string) => {
    setCurrentQuestion(question);
  };

  const handleFollowUp = (question: string) => {
    handleQuestionSubmit(question);
  };

  return (
    <div className="question-interface">
      <div className="question-input-section">
        <h3>Ask Your Question!</h3>
        <div className="question-input-container">
          <input
            type="text"
            value={currentQuestion}
            onChange={(e) => setCurrentQuestion(e.target.value)}
            placeholder="What would you like to know about this tree?"
            className="question-input"
            onKeyPress={(e) => e.key === 'Enter' && handleQuestionSubmit(currentQuestion)}
          />
          <button 
            onClick={() => handleQuestionSubmit(currentQuestion)}
            disabled={isLoading || !currentQuestion.trim()}
            className="submit-question-btn"
          >
            {isLoading ? '🤔' : 'Ask!'}
          </button>
        </div>
      </div>

      <div className="suggested-questions">
        <h4>Need Ideas? Try These Questions:</h4>
        <div className="suggested-questions-grid">
          {tree.suggestedQuestions.map((question, index) => (
            <button
              key={index}
              onClick={() => handleSuggestedQuestion(question)}
              className="suggested-question-btn"
            >
              {question}
            </button>
          ))}
        </div>
      </div>

      {askedQuestions.length > 0 && (
        <div className="questions-and-answers">
          <h3>What You've Learned:</h3>
          {askedQuestions.map((qa, index) => (
            <div key={index} className="qa-item">
              <div className="question-display">
                <strong>Q: {qa.question}</strong>
              </div>
              <div className="answer-display">
                <p>{qa.answer}</p>
              </div>
              {qa.followUps.length > 0 && (
                <div className="follow-ups">
                  <p className="follow-up-prompt">Want to learn more? Try asking:</p>
                  <div className="follow-up-questions">
                    {qa.followUps.map((followUp, fIndex) => (
                      <button
                        key={fIndex}
                        onClick={() => handleFollowUp(followUp)}
                        className="follow-up-btn"
                      >
                        {followUp}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default QuestionInterface;